// extracted by mini-css-extract-plugin
export default {"main":"BigWork_main__NiIUS","modal-open":"BigWork_modal-open__N6scb","imgContainer":"BigWork_imgContainer__+0uGw","imgBox":"BigWork_imgBox__waOUy","img":"BigWork_img__XPNmV"};